'use strict';

export class SMask {
    constructor() {
        this._isFilling = false;
        this._symMask = /[90a*]/gi;
        this._koefFont = 1.1;
    }

    setMask(field, mask) {
        if (!this.isValid(mask)) {
            $ns.add({
                type: 'warning',
                time: new Date().toLocaleString(),
                title: i18next.t("input_mask_incorrect"),
                text: `${i18next.t("input_mask_incorrect")} : ` + mask
            });
            return
        }
        this._mask = mask;
        this._field = field;
        field.maxLength = mask.length;
        this._placeholder = mask.replace(this._symMask, '_');
        field.oncut = () => false;
        field.onpaste = () => false;
        field.onfocus = () => this._onInputFocus(field);
        this._textChange = field.onchange;
    }

    delMask() {
        this._hidePlaceholder();
        document.onkeydown = null;
        document.onkeyup = null;
        document.onmouseup = null;
        this._textChange = null;
        if (this._field) {
            this._field.onblur = null;
            this._field.oncut = null;
            this._field.onpaste = null;
            this._field.onfocus = null;
            this._field.removeAttribute('maxLength');
            this._field = null;
        }
    }

    get value() {
        return this._value;
    }

    /**
     * отображение маски ввода
     *
     * @memberof SMask
     */
    get showPlaceholder() {
        return this._showPh;
    }
    set showPlaceholder(v) {
        this._showPh = v;
    }

    _onInputPaste(field) {
        field.value = this._placeholder;
        const index = field.value.indexOf('_');
        field.setSelectionRange(index, index);
        this._isFilling = false;
    }

    _showPlaceholder(field, value) {
        if (!this._showPh) return;
        const font = parseInt(field.style.fontSize);
        field.offsetParent.style.fontSize = `${Math.floor(font / 1.1)}px`;
        field.offsetParent.setAttribute('data-value', value);
        field.offsetParent.style.overflow = 'visible';
        field.offsetParent.classList.add('span-placeholder');
    }

    _hidePlaceholder() {
        this._field.offsetParent.style.overflow = 'hidden';
        this._field.offsetParent.style.fontSize = '';
        this._field.offsetParent.classList.remove('span-placeholder');
    }
    _calcValue(value) {
        const lv = value.length;
        const lp = this._placeholder.length;
        const lr = lp - lv;
        if (lr > 0) {
            return this._placeholder.substr(0, lr) + value;
        }
        return value;
    }

    isValid(value) {
        let fields = value.match(/[A-Za-zА-ЯЁа-яё0-9_\*]*/gm).filter(e => e != '')
        return fields.reduce(((accumulator, currentValue) => {
            return accumulator && !(currentValue.includes("0") && currentValue.includes("*"))
        }), true);
    }

    _onInputFocus(field) {
        field.value = !this._isFilling ? this._calcValue(field.value) : this._calcValue(this._prevValue);
        const indexCursor = field.value.indexOf('_');
        if (indexCursor !== -1) {
            field.setSelectionRange(indexCursor, indexCursor);
        }
        this._showPlaceholder(field, this._mask);

        document.onkeydown = (evt) => {
            evt.preventDefault();
            if (evt.which === window._enums.ButtonKeyCode.DELETE && evt.ctrlKey) {
                return false;
            }
            let currentValue = field.value;
            if (evt.which === window._enums.ButtonKeyCode.BACKSPACE || evt.which === window._enums.ButtonKeyCode.DELETE) {
                let startIndex = this._field.selectionStart;
                if (this._field.selectionStart === field.selectionEnd) {
                    const inss = field.value.search(/\w/);
                    if (startIndex === 0 || inss >= startIndex) {
                        return false;
                    }
                    if (/[9|0|a|*]/.test(this._mask[this._field.selectionStart - 1])) {
                        if (evt.which !== window._enums.ButtonKeyCode.DELETE) startIndex -= 1;
                        let first = field.value.slice(0, startIndex);
                        let last = field.value.slice(startIndex + 1);
                        field.value = `${first}_${last}`;
                    } else if (/\W/.test(this._mask[this._field.selectionStart - 1])) {
                        if (evt.which !== window._enums.ButtonKeyCode.DELETE) startIndex -= 2;
                        let first = field.value.slice(0, startIndex);
                        let last = field.value.slice(startIndex + 1);
                        field.value = `${first}_${last}`;
                    }

                } else {
                    let lastIndex = field.selectionEnd;
                    field.value = currentValue.replace(/\w/g, (match, index) => {
                        return (index >= startIndex && index < lastIndex && /[9|0|a|*]/.test(this._mask[index])) ? '_' : match;
                    });
                    startIndex = field.value.indexOf('_');
                }
                field.setSelectionRange(startIndex, startIndex);
                this._prevValue = field.value;
                if (field.value === this._placeholder) {
                    this._isFilling = false;
                }
            } else if (evt.key.length === 1) {
                if (this._field.selectionStart !== field.selectionEnd) {
                    let startIndex = this._field.selectionStart;
                    let lastIndex = field.selectionEnd;
                    field.value = currentValue.replace(/\w/g, (match, index) => {
                        return (index >= startIndex && index < lastIndex && /[9|0|a|*]/.test(this._mask[index])) ? '_' : match;
                    });
                    startIndex = field.value.indexOf('_');
                    field.setSelectionRange(startIndex, startIndex);
                }
                return this._setInputChar(evt.key, field);
            } else if (evt.which === window._enums.ButtonKeyCode.RIGHT) {
                field.setSelectionRange(field.selectionStart + 1, field.selectionStart + 1);
            } else if (evt.which === window._enums.ButtonKeyCode.LEFT) {
                if (field.selectionStart === 0) {
                    return;
                }
                field.setSelectionRange(field.selectionStart - 1, field.selectionStart - 1);
            } else if (evt.which === window._enums.ButtonKeyCode.ENTER) {
                field.blur();
            }
        };

        field.onblur = (evt) => {
            let val = field.value.replace(/_/g, (match, index) => {
                return (this._mask[index] === '0') ? '' : match;
            });
            if (this._textChange && !val.includes('_')) {
                if (!isNaN(Number(this._mask))) {
                    const length = val.includes('.') ? val.split('.').pop().length : 0;
                    val = Number(val).toFixed(length);
                }
                this._value = val;
                this._textChange(evt);
            }
            if (!this._isFilling) {
                field.value = '';
            }
            this._hidePlaceholder();
            document.onkeydown = null;
            document.onmouseup = null;
        };
    }

    SetValue(value) {
        value = String(value)
        if (!value) {
            return;
        }

        let ind = value.indexOf(value.match(/[A-Za-zА-ЯЁа-яё0-9\s]/)[0])
        console.log(this._mask)

        if (ind > -1) {
            value = value.substr(ind)
        }
        value = value.split("").reverse().join("")
        ind = value.indexOf(value.match(/[A-Za-zА-ЯЁа-яё0-9\s]/)[0])
        if (ind > -1) {
            value = value.substr(ind)
        }
        value = value.split("").reverse().join("")

        const mark = this._placeholder.match(/[_]*/gm).filter(e => e != '')
        const sep = value.match(/[^A-Za-zА-ЯЁа-яё0-9_]*/gm).filter(e => e != '')

        const intervalsOfValue = value.match(/[A-Za-zА-ЯЁа-яё0-9_\*]*/gm).filter(e => e != '')
        const intervalsOfMask = this._mask.match(/[A-Za-zА-ЯЁа-яё0-9_\*]*/gm).filter(e => e != '')
        let newValues = []
        for (let i = 0; i < intervalsOfMask.length && i < intervalsOfValue.length; ++i) {
            let maskInterval = intervalsOfMask[i];
            let valueInerval = intervalsOfValue[i];
            const length = maskInterval.length

            let suffSumm = new Array(length)
            suffSumm[length - 1] = (maskInterval[length - 1] === "9")
            for (let j = length - 2; j >= 0; --j) {
                suffSumm[j] = suffSumm[j + 1] + (maskInterval[j] === "9")
            }
            let newValue = ""

            let f = false
            for (let j = 0, k = 0; k < maskInterval.length;) {
                if ((maskInterval[k] === "9") || ((suffSumm[k] < valueInerval.length - j) && f) || (maskInterval.length - k <= valueInerval.length - j)) {
                    newValue += valueInerval[j]
                    ++j
                    ++k
                    f = true
                    continue
                }
                newValue += "_"
                ++k
            }
            newValues.push(newValue)
        }
        let result = ""
        for (let i = 0; i < sep.length; ++i) {
            result += newValues[i] + sep[i]
        }
        result += newValues[newValues.length - 1]


        this._field.value = this._placeholder;
        const indexCursor = 0;
        if (indexCursor !== -1) {
            this._field.setSelectionRange(indexCursor, indexCursor);
        }
        this._showPlaceholder(this._field, this._mask);

        for (let i = 0; i < result.length; i++) {

            const key = result[i];
            this._setInputChar(key, this._field);
        }
    }
    _setInputChar(key, field) {
        if (field.selectionStart === field.value.length) {
            return;
        }
        let oldValue = field.value;
        if (/[^$A-Za-z0-9*_]/.test(this._mask[this._field.selectionStart])) {
            field.selectionStart += 1;
        }

        let strRX = this._getStringRegExp(this._mask[field.selectionStart]);
        let rx = new RegExp(strRX);
        if (!rx.test(key) && key != "_") {
            field.value = oldValue;
            return false;
        }

        let startIndex = field.selectionStart + 1;
        field.value = field.value.replace(/[A-Za-zА-ЯЁа-яё0-9_]/g, (match, index) => (index === field.selectionStart) ? key : field.value[index]);
        const indexCursor = field.value.indexOf('_');
        if (indexCursor === -1) {
            startIndex = field.value.length;
        }
        field.setSelectionRange(startIndex, startIndex);
        this._isFilling = true;
        this._prevValue = field.value;
    }

    _getStringRegExp(key) {
        let rx;
        switch (key) {
            case '9': case '0': rx = '[0-9]'; break;
            case 'a': rx = `[A-Za-zА-ЯЁа-яё]`; break;
            default: rx = `[A-Za-zА-ЯЁа-яё0-9]`; break;
        }
        return rx;
    }
};
